import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiRequest from "../../../utils/vendor/apiRequest";
import usePost from "../../../hooks/api/usePost";
import Alert from "../../ui/utils/Alert";
import FileInputField from "../../ui/form/FileInputField";

const ProductImageEdit = ({ data, closeModal, callback }) => {
  const [preview, setPreview] = useState(null);

  const {
    error,
    isLoading: loading,
    post,
  } = usePost(apiRequest.editProductImage);

  const formik = useFormik({
    initialValues: {
      image: "",
    },
    validationSchema: Yup.object({
      image: Yup.mixed()
        .required("Image is required")
        .test(
          "fileType",
          "Invalid file type",
          (value) =>
            value &&
            ["image/jpeg", "image/png", "image/webp"].includes(value.type)
        ),
    }),
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("image", values.image);

      const response = await post({
        data: { formData, id: data?._id },
      });

      if (response?.response) {
        callback?.();
        closeModal();
      }
    },
  });

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">
        Update Product Image
      </h2>
      <div className="border-b" />

      {error && <Alert message={error} type="error" />}

      <div className="px-4 py-4">
        <FileInputField
          id="image"
          label="Select Image"
          accept="image/*"
          error={formik.touched.image && formik.errors.image}
          onChange={(e) => {
            const file = e.currentTarget.files?.[0];
            if (!file) return;

            setPreview(URL.createObjectURL(file));
            formik.setFieldValue("image", file);

            // 🔥 AUTO SUBMIT ON IMAGE SELECT
            setTimeout(() => {
              formik.submitForm();
            }, 100);
          }}
        />

        {preview && (
          <div className="mt-3 flex justify-center">
            <img
              src={preview}
              alt="Preview"
              className="w-24 h-24 object-contain border rounded-lg"
            />
          </div>
        )}

        {loading && (
          <p className="text-center text-sm text-gray-500 mt-3">
            Uploading image...
          </p>
        )}
      </div>
    </div>
  );
};

export default ProductImageEdit;
